const formatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
})

const formatterWithFractionDigits = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 2,
})

export const moneyFormatter = (amount?: number, withFractionDigits = false) => {
    if (amount === undefined) {
        return ''
    }

    return withFractionDigits
        ? formatterWithFractionDigits.format(amount)
        : formatter.format(amount)
}
